import { Badge, type BadgeProps } from "@/components/ui/Badge";
import type { UsageRun } from "../types";

const VARIANTS: Record<string, BadgeProps["variant"]> = {
  completed: "green",
  error: "red",
  running: "blue",
};

/** CLI and connector runs have no end, so they show no status. */
export const RunStatus = ({ run }: { run: UsageRun }) => {
  if (run.run_type === "cli" || run.run_type === "connector") {
    return <span className="text-zinc-500">—</span>;
  }
  const label = run.status.charAt(0).toUpperCase() + run.status.slice(1);
  return <Badge variant={VARIANTS[run.status] ?? "default"}>{label}</Badge>;
};
